import { AuthAPI } from './types'

export const authApi: AuthAPI = ky => {
  return {
    async login({ username, password }) {
      return await ky('token/', {
        method: 'post',
        json: { heartlineId: username, password }
      }).json()
    },

    async refresh({ refresh }) {
      return await ky('token/refresh/', {
        method: 'post',
        json: { refresh },
        hooks: {
          afterResponse: []
        }
      }).json()
    }
  }
}
